export default {"src":"/_next/static/media/icon.c2f6795b.svg","height":287,"width":260};